
export default {
  head() {
    return {
      title: "Création site internet Alsace | À partir 69€HT/mois",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Vous voulez créer un site web pour votre activité en Alsace ? Découvrez les solutions digitales à prix accessible proposées par l’agence de communication ALEO !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Création site internet Alsace | À partir 69€HT/mois",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Vous voulez créer un site web pour votre activité en Alsace ? Découvrez les solutions digitales à prix accessible proposées par l’agence ALEO !",
        },
      ],
    };
  },
};
